import { useContext } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, fontWeights } from '@/styles'
import Tooltip from '@/components/popper-tooltip'
import { show as showSelectRecipientFormModal } from '../add-signer/add-recipient-form-modal'
import Context from '../context'

const DropdownComponentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const DropdownColorScheme = styled.span`
  display: inline-block;
  width: 8px;
  height: 35px;
  height: ${props => (props.condensed ? '35px' : '16px')};
  margin-right: 8px;
  border-radius: 2px;
  background: ${props => props.color};
  flex-shrink: 0;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${props => props.maxWidth || 190}px;
`

const DropdownName = styled.p`
  margin: 0;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const DropdownEmail = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${colors.grey56};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const EditContainer = styled.div`
  justify-self: end;
`

const EditText = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${props => (props.disableEdit ? colors.grey64 : colors.link)};
`

const TooltipWrapper = styled.div`
  p {
    max-width: 220px;
    margin: 0;
    padding: 0;
  }
`

const FullText = styled.div`
  font-weight: ${fontWeights.medium};
  font-size: 14px;
  line-height: 16px;
`

const StyledTooltip = styled(Tooltip)`
  > button {
    width: 100%;
  }
`

const DropdownComponent = ({
  color,
  name,
  email,
  showEdit = false,
  user,
  contractId,
  maxWidth,
  signees,
  setSignees,
  disableEdit = false,
  items
}) => {
  const { t } = useTranslation()

  const { fileMetadata, setFileMetadata, user: currentUser, setUser } = useContext(Context)

  const handleEdit = () => {
    if (!disableEdit)
      showSelectRecipientFormModal({
        contractId,
        user,
        editing: true,
        signees,
        setSignees,
        fileMetadata,
        setFileMetadata,
        currentUser,
        setUser,
        items
      })
  }

  return (
    <DropdownComponentWrapper>
      <ContentWrapper>
        <DropdownColorScheme color={color} condensed={email} />
        <NameWrapper maxWidth={maxWidth}>
          <DropdownName>{name}</DropdownName>
          {email && <DropdownEmail>{email}</DropdownEmail>}
        </NameWrapper>
      </ContentWrapper>
      {showEdit &&
        (disableEdit ? (
          <StyledTooltip
            enabled={true}
            size="medium"
            content={
              <TooltipWrapper>
                <FullText>
                  {t(
                    'l.contract_edit.add_recipients.disabled_edit.text',
                    'As this recipient was added from the applicant list, their information is automatically pulled from their application and cannot be modified.'
                  )}
                </FullText>
              </TooltipWrapper>
            }
            placement={'top'}
          >
            <EditContainer>
              <EditText disableEdit={disableEdit}>{t('common.edit', 'Edit')}</EditText>
            </EditContainer>
          </StyledTooltip>
        ) : (
          <EditContainer onClick={handleEdit}>
            <EditText>{t('common.edit', 'Edit')}</EditText>
          </EditContainer>
        ))}
    </DropdownComponentWrapper>
  )
}

export default DropdownComponent
